import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

export default function PrintPOBarcodeDialog({
  visible,
  items,
  onHide,
  onPrint
}) {
  const [copiesMap, setCopiesMap] = useState({});
  const inputRefs = useRef([]);
  const printBtnRef = useRef(null);
  const [applyToAll, setApplyToAll] = useState(false);

  useEffect(() => {
    if (!applyToAll || !items.length) return;

    const firstValue = copiesMap[items[0].id] || 1;
    const synced = {};
    items.forEach(it => {
        synced[it.id] = firstValue;
    });
    setCopiesMap(synced);
  }, [applyToAll]);

  useEffect(() => {
    if (visible) {
      const init = {};
      items.forEach(it => {
        init[it.id] = it.default_copies || 1;
      });
      setCopiesMap(init);

      // focus first input
      setTimeout(() => {
        inputRefs.current[0]?.focus();
        inputRefs.current[0]?.select();
      }, 150);
    }
  }, [visible, items]);

  const handleEnter = (idx) => {
    if (idx < items.length - 1) {
        const nextInput = inputRefs.current[idx + 1];
        if (nextInput) {
        nextInput.focus();
        nextInput.select();  
        }
    } else {
        printBtnRef.current?.focus();
    }
  };

  const updateCopies = (itemId, value) => {
    setCopiesMap(prev => {
        if (applyToAll) {
        const next = {};
        items.forEach(it => {
            next[it.id] = value || 0;
        });
        return next;
        }

        return {
        ...prev,
        [itemId]: value || 0,
        };
    });
    };

  const preparedItems = items.map(it => ({
    ...it,
    copies: copiesMap[it.id] || 1
  }));

  return (
    <Dialog
      header="Print Barcode Labels"
      visible={visible}
      style={{ width: '55rem' }}
      modal
      onHide={onHide}
    >
      <div className="grid">
        {/* LEFT: Inputs */}
        <div className="col-7">
            <div className="flex align-items-center mb-3">
                <Checkbox
                    inputId="applyAll"
                    checked={applyToAll}
                    onChange={e => setApplyToAll(e.checked)}
                />
                <label htmlFor="applyAll" className="ml-2">
                    Apply copies to all items
                </label>
            </div>

          {items.map((it, idx) => (
            <div key={it.id} className="flex align-items-center mb-3">
              <div className="flex-grow-1">
                <div className="font-semibold">{it.product_name}</div>
                <small className="text-600">Batch: {it.batch_number}</small>
              </div>

              <InputNumber
                ref={el => inputRefs.current[idx] = el?.getInput?.()}
                value={copiesMap[it.id] || 1}
                min={0}
                max={99}
                style={{ width: '6rem' }}
                onValueChange={e => updateCopies(it.id, e.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleEnter(idx);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-content-end mt-4 gap-2">
        <Button
          label="Cancel"
          className="p-button-text"
          onClick={onHide}
        />
        <Button
          ref={printBtnRef}
          label="Print"
          icon="pi pi-print"
          onClick={() => onPrint(preparedItems)}
        />
      </div>
    </Dialog>
  );
}
